/**
 * Given a list of active filters and a filter type, returns an array containing
 * just the selected values for the given type.
 * @param {Array} activeFilters - An array of active filter objects.
 * @param {string} type - The filter type to extract values for.
 * @returns {Array} An array of strings or numbers representing selected values.
 */
const getSelected = (activeFilters, type) => activeFilters
  .filter(({ type: filterType }) => filterType === type)
  .map(({ value }) => value);

export default getSelected;
